<template>
  <div class="offer-tooltip__data">
    <span class="custom-icon--arrow-top" @click="toggle" />
    <span v-if="loading" class="loader-gif" />

    <div class="offer-tooltip__data--content" v-if="isOpen">
      <slot :data="data">
        {{ data }}
      </slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import { AutoCloseMixin } from '@/components/AutoCloseMixin'

@Component({
  props: {
    isDynamic: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
})
export default class Offer extends Vue {
  data = null
  isOpen = false
  loading = false

  toggle () {
    if (this.isDynamic && this.data === null) {
      this.loading = true
      this.$emit('load', this.load.bind(this))
    } else if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  load (data) {
    this.loading = false
    this.data = data
    this.open()
  }

  open () {
    this.isOpen = true
    this.AutoCloseMixin = new AutoCloseMixin(this.$el, this.close)
  }

  close () {
    this.isOpen = false
    this.AutoCloseMixin.cleanup()
    this.AutoCloseMixin = null
  }
}
</script>

<style lang="scss" scoped>
.offer-tooltip__data {
  display: inline-block;
  position: relative;

  &--content {
    position: absolute;
    left: 10px;
    bottom: 25px;
    width: 200px;
    transform: translate(-50%, 0);
    background-color: #fff;
    color: #535353;
    padding: 15px;
    box-shadow: 0 0 20px 0 rgba(0,0,0,.3);
    z-index: 1;

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 100%;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 10px 10px 0;
      border-color: #fff transparent transparent;
      left: 50%;
      margin-left: -10px;
    }

    .custom-icon--info {
      font-size: 21px;
    }

    p {
      display: inline-block;
      font-size: 11px;
      text-transform: uppercase;
      color: #005ca9;
      font-family: 'Gotham';
      font-weight: 700;
      font-style: normal;
      vertical-align: top;
      margin: 6px 0 0;
    }

    ul {
      list-style: none;
      padding: 5px 0 0;
    }

    li {
      display: inline-block;
      padding: 3px 0;

      &::after {
        content: '/';
        display: inline-block;
        padding: 0 3px;
      }

      &:last-child::after {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offers-list/Tooltip.vue